import { initialState } from '@procurify/webapp/src/core/stores/global/reducers'

import { initialState as i18nInitialState } from '../../../webapp/src/stores/i18n/reducers'
import { initialState as payApprovalsInitialState } from '../../../webapp/src/stores/payApprovals/reducers'
import { initialState as payCardManagementInitialState } from '../../../webapp/src/stores/payCardManagement/reducers'
import { UserMock } from '../../../webapp/src/tests/mocks/user.factory'

export const defaultStore = {
  i18n: i18nInitialState,
  global: {
    ...initialState,
    hasFeatureFlagsResolved: true,
    hasEntitlementResolved: true,
    user: UserMock.build(),
  },
  payApprovals: payApprovalsInitialState,
  payCardManagement: payCardManagementInitialState,
}
